module.exports = __webpack_public_path__ + "img/gauge.762e7ef0.svg";